import React, { useState, useEffect } from 'react';
import { useLanguageContext } from '../contexts/LanguageContext';

const LanguageChangeIndicator: React.FC = () => {
  const { language } = useLanguageContext();
  const [isVisible, setIsVisible] = useState(false);
  const [isFadingOut, setIsFadingOut] = useState(false);
  const [currentLang, setCurrentLang] = useState(language);

  useEffect(() => {
    if (language !== currentLang) {
      setIsVisible(true);
      setIsFadingOut(false);
      setCurrentLang(language);

      // Start fade-out after 2.5 seconds
      const fadeTimer = setTimeout(() => {
        setIsFadingOut(true);
      }, 2500);

      // Remove completely after 3 seconds (2.5s + 0.5s fade)
      const hideTimer = setTimeout(() => {
        setIsVisible(false);
      }, 3000);

      return () => {
        clearTimeout(fadeTimer);
        clearTimeout(hideTimer);
      };
    }
  }, [language]); // Only depend on language, not currentLang

  if (!isVisible) return null;

  const langNames = {
    fr: { name: 'Français', flag: '🇫🇷' },
    en: { name: 'English', flag: '🇺🇸' },
    es: { name: 'Español', flag: '🇪🇸' },
    de: { name: 'Deutsch', flag: '🇩🇪' },
    it: { name: 'Italiano', flag: '🇮🇹' },
    pt: { name: 'Português', flag: '🇵🇹' },
    nl: { name: 'Nederlands', flag: '🇳🇱' }
  };

  const currentLangInfo = langNames[language];

  return (
    <div
      className={`fixed top-20 right-6 z-50 transition-all duration-500 ${
        isFadingOut ? 'opacity-0 translate-x-4' : 'opacity-100 translate-x-0 animate-bounce'
      }`}
    >
      <div className="bg-white border border-blue-200 rounded-lg shadow-lg px-4 py-2 flex items-center gap-2">
        <div className="text-2xl">{currentLangInfo.flag}</div>
        <div className="text-sm font-medium text-blue-600">
          {currentLangInfo.name}
        </div>
        <div className="text-green-500 text-lg">✓</div>
      </div>
    </div>
  );
};

export default LanguageChangeIndicator;